import { render, staticRenderFns } from "./ClientInformation.vue?vue&type=template&id=ec7999f6"
import script from "./ClientInformation.vue?vue&type=script&lang=ts"
export * from "./ClientInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec7999f6')) {
      api.createRecord('ec7999f6', component.options)
    } else {
      api.reload('ec7999f6', component.options)
    }
    module.hot.accept("./ClientInformation.vue?vue&type=template&id=ec7999f6", function () {
      api.rerender('ec7999f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/projectDetails/CarePlanRightSide/ClientInformation.vue"
export default component.exports